export default __webpack_public_path__ + "static/media/main3.3b5ffdb8.png";